import { downloadDataAsCsv } from '../../../utils/downloadHelpers';
import { Link } from '@heroui/react';
import { LuDownload, LuLoader } from 'react-icons/lu';

interface CsvDownloadButtonProps<T extends Record<string, any>> {
	data: T[] | undefined;
	filename: string;
	className?: string;
	reverseIconColor?: boolean;
	title?: string;
	dataLoading?: boolean;
}

export function CsvDownloadButton<T extends Record<string, any>>({
	data,
	filename,
	className = '',
	reverseIconColor = false,
	title = 'Download data as CSV',
	dataLoading = false,
}: CsvDownloadButtonProps<T>) {
	const handleDownload = () => {
		if (data && data.length > 0) {
			downloadDataAsCsv(data, filename);
		} else {
			console.warn('No data available to download');
		}
	};

	const hasValidData = data && data.length > 0 && data[0];

	return (
		<Link
			className={`${className} absolute z-40 cursor-pointer pr-2`}
			style={{ right: 35, top: 10 }}
			aria-label={title}
			title={title}
			onPress={handleDownload}
			isDisabled={!hasValidData}
		>
			{(dataLoading && <LuLoader color={reverseIconColor ? '#FFFFFF' : '#151B1E'} size={16} className="rounded-none absolute" />) || (
				<LuDownload color={reverseIconColor ? '#FFFFFF' : '#151B1E'} size={16} className="rounded-none absolute" />
			)}
		</Link>
	);
}
